(() => {
  const namespace = "PandaRegularSlider";

  if (window[namespace]) {
    window[namespace].init(document);
    return;
  }

  function init(root = document, attempts = 20) {
    if (!window.Swiper) {
      if (attempts > 0) {
        window.setTimeout(() => init(root, attempts - 1), 100);
      }
      return;
    }

    root.querySelectorAll(".slider--regular .slider__slides").forEach((slider) => {
      if (slider.swiper) return;

      const section = slider.closest(".slider--regular");
      if (!section) return;

      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 20,
        watchOverflow: true,
        navigation: {
          prevEl: section.querySelector(".prev"),
          nextEl: section.querySelector(".next"),
        },
        pagination: {
          el: section.querySelector(".slider__pagination"),
          clickable: true,
        },
        breakpoints: {
          630: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          991: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
        },
      });
    });
  }

  window[namespace] = { init };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
